export enum PaymentTypeEnum {
    TDS = 0,
    MAIL_ORDER = 1
}